import { useEffect, useState } from 'react';
import { Share, X, Plus } from 'lucide-react';
import {
  dismissInstallPrompt,
  getDeferredInstallPrompt,
  isIosDevice,
  isStandaloneApp,
  isInstallDismissed,
  promptNativeInstall,
  subscribeInstallPrompt,
} from '@/lib/pwaInstall';

export function InstallAppBanner() {
  const [visible, setVisible] = useState(false);
  const [ios, setIos] = useState(false);
  const [installing, setInstalling] = useState(false);

  useEffect(() => {
    const sync = () => {
      if (isStandaloneApp() || isInstallDismissed()) {
        setVisible(false);
        return;
      }
      const onIos = isIosDevice();
      setIos(onIos);
      setVisible(onIos || Boolean(getDeferredInstallPrompt()));
    };
    sync();
    return subscribeInstallPrompt(sync);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    dismissInstallPrompt();
    setVisible(false);
  };

  const install = async () => {
    setInstalling(true);
    try {
      const ok = await promptNativeInstall();
      if (ok) setVisible(false);
    } finally {
      setInstalling(false);
    }
  };

  return (
    <div className="border-b border-makhe-line bg-makhe-paper">
      <div className="mx-auto flex max-w-6xl items-start gap-3 px-5 py-3">
        <div className="mt-0.5 h-9 w-9 shrink-0 overflow-hidden rounded-xl">
          <img src="/icons/icon-192.png" alt="" className="h-full w-full object-cover" />
        </div>

        <div className="min-w-0 flex-1">
          <p className="font-display text-sm">Install Makhe on your phone</p>
          {ios ? (
            <p className="mt-1 text-xs leading-relaxed text-makhe-muted">
              Tap{' '}
              <Share size={12} className="inline -translate-y-px" aria-hidden />{' '}
              <strong className="font-medium text-makhe-ink">Share</strong> in Safari, then{' '}
              <Plus size={12} className="inline -translate-y-px" aria-hidden />{' '}
              <strong className="font-medium text-makhe-ink">Add to Home Screen</strong>. Opens
              like an app — and enables push notifications on iPhone.
            </p>
          ) : (
            <p className="mt-1 text-xs text-makhe-muted">
              Add Makhe to your home screen for faster access and notifications.
            </p>
          )}

          {!ios && (
            <button
              type="button"
              onClick={() => void install()}
              disabled={installing}
              className="mt-2 rounded-full bg-makhe-ink px-4 py-1.5 text-[10px] uppercase tracking-widest text-makhe-bg disabled:opacity-60"
            >
              {installing ? 'Installing…' : 'Install app'}
            </button>
          )}
        </div>

        <button
          type="button"
          onClick={dismiss}
          aria-label="Dismiss install prompt"
          className="shrink-0 rounded-full p-1 text-makhe-muted hover:text-makhe-ink"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
